<script>
    import Contributor from "./Contributor.svelte";
    import ContributorList from "./ContributorList.svelte";
    import InviteContributorPlaceholder from "./InviteContributorPlaceholder.svelte";
    import InviteContributorsDialog from "../dialogs/InviteContributorsDialog.svelte";
    import Overlay from "../Overlay.svelte";
    import ProfilePicture from "../ProfilePicture.svelte";
    import ProjectLib from "../../models/participaid/Project.js";

    import LoadingSpinner from "../LoadingSpinner.svelte";
    import Line from "../Line.svelte";

    export let isOwner;
    export let project;
    export let contributors = [];
    export let myUserId;
    export let colors;
    export let projectValuation;

    $: projectId = project && project.id;
    $: isMe = (contributor) => contributor.user.id == myUserId;
    $: isOther = (contributor) => !isMe(contributor);
    $: meContributor = contributors.find(isMe);
    $: otherContributors = contributors.filter(isOther);
    $: loading = !project || !myUserId;
    // TODO: implement isLive property in GQL server
    $: allowEdit = project && ProjectLib.hasFieldsConfigured(project) && !project.isClosed && !project.isSettled;

    const hasOwnership = (contributor) => isOwner || isMe(contributor);
</script>

{#if loading}
    <LoadingSpinner light />

{:else}
    {#if meContributor}
        <Contributor
            model={meContributor}
            {projectId}
            {allowEdit}
            {myUserId}
            {isOwner}
            {projectValuation}
            {colors}
            on:newEntryDialog
            on:deletion
            on:reinvite
        />
        <Line orientation="vertical" style="margin: 0 5px;"/>
    {/if}

    {#each otherContributors as contributor}
        <Contributor
                model={contributor}
                {projectId}
                {allowEdit}
                {myUserId}
                {isOwner}
                {projectValuation}
                {colors}
                on:newEntryDialog
                on:deletion
        />
    {/each}

    {#if isOwner && allowEdit}
        <InviteContributorPlaceholder
                {project}
                {myUserId}
                on:invite
        />
    {/if}
{/if}